module.exports = __webpack_public_path__ + "img/13_DSC8074.bfee54ef.jpg";